import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/components/common/messageservice';
import { WebPage } from '../../shared/web-page';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FinanceiroService } from '../financeiro.service';
import { UnidadeService } from '../../shared/services/unidade.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ConfirmationService } from 'primeng/primeng';
import { FaseService } from '../../fase/fase.service';
import { EditalCredenciamentoService } from '../../editalCredenciamento/edital-credenciamento.service';
import { Prestador } from '../../../models/prestador';
import { TipoFornecedor } from '../../../models/tipoFornecedor';
import { Observable } from 'rxjs/Observable';
import { switchMap, map, merge } from 'rxjs/operators';
import { StatusControleLancamento } from '../../../models/statusControleLancamento';

@Component({
  selector: 'emprego-na-pistacadastar-valor-despesa-fornecedor-form',
  templateUrl: './cadastar-valor-despesa-fornecedor-form.component.html',
  styleUrls: ['./cadastar-valor-despesa-fornecedor-form.component.css']
})
export class CadastarValorDespesaFornecedorFormComponent extends WebPage implements OnInit {

  public id: any;
  public form: FormGroup;
  public isSubmitted = false;
  public tipoFornecedores: any[];
  public podeHabilitarMes = false;
  public unidades: any[];
  public fases: any[];
  public tipoDespesas: any[];
  public editais: any[];
  public meses: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  public anos: number[] = [];
  public valorDespesa: any;

  constructor(messageService: MessageService,
    private fb: FormBuilder,
    private _financeiroService: FinanceiroService,
    private _unidadeService: UnidadeService,
    private router: Router,
    private route: ActivatedRoute,
    private _editalCredenciamentoService: EditalCredenciamentoService,
    private _faseService: FaseService,
    private confirmationService: ConfirmationService, ) {
    super(messageService);
    this.buildForm();

    this.route.paramMap.subscribe(params =>
      this.id = params.get('id')
    );

  }

  ngOnInit() {
    this.getTipoFornecedores();
    this.getFases();
    this.criarAnos();

    this.habilitarMes();
    // this.getTipoDespesas();

    if (this.id !== null) {
      // console.log('Editar');
      this.getByIdValorDespesas();
    } else {
      // console.log('cadastrar');
    }
  }
  criarAnos() {
    let anoAtual = new Date().getFullYear();
    for (let index = anoAtual; 2018 <= index; index--) {
      this.anos.push(index);
    }

  }
  buildForm() {
    this.form = this.fb.group({
      idValorDespesa: [null],
      idFase: [null, [Validators.required]],
      idUnidade: [null, [Validators.required]],
      idTipoFornecedor: [null, [Validators.required]],
      idEditalCredenciamento: [null],
      idTipoDespesa: [null, [Validators.required]],
      mes: [null],
      valor: [null, Validators.required],
      ano: [null, Validators.required],
      ativo: [true]
    });
  }

  getByIdValorDespesas() {
    this._financeiroService.getByIdValorDespesas(this.id)
      .switchMap(data => {

        this.valorDespesa = data;
        let Observer;

        if (data.idFase !== null && data.idTipoFornecedor !== null && data.idUnidade !== null) {
          const idFornecedor = (data.idTipoFornecedor === TipoFornecedor.CFC ? Prestador.idCfc : Prestador.idClinica);

          Observer = Observable.combineLatest(
            this._unidadeService.getUnidadesParticipantesByFase(data.idFase),
            this._financeiroService.getTipoDespesasByIdFornecedor(data.idTipoFornecedor),
            this._editalCredenciamentoService.getEditalByIdUnidadeAnIdFase(data.idUnidade, data.idFase, idFornecedor)
          );
        } else {
          Observer = Observable.combineLatest(
            this._unidadeService.getUnidadesParticipantesByFase(data.idFase),
            this._financeiroService.getTipoDespesasByIdFornecedor(data.idTipoFornecedor)
          );
        }
        return Observer;
      })
      .subscribe((data) => {

        this.unidades = data[0];
        this.tipoDespesas = data[1];

        if (data.length > 2) {
          this.editais = data[2];
          this.habilitaEdital(data[2].idEditalCredenciamento);
        }

        console.log(this.valorDespesa);


        this.form.patchValue({
          idValorDespesa: this.id,
          idFase: this.valorDespesa.idFase,
          idUnidade: this.valorDespesa.idUnidade,
          idTipoFornecedor: this.valorDespesa.idTipoFornecedor,
          idEditalCredenciamento: this.valorDespesa.idEditalCredenciamento,
          idTipoDespesa: this.valorDespesa.idTipoDespesa,
          mes: this.valorDespesa.mes,
          ano: this.valorDespesa.ano,
          valor: this.valorDespesa.valor,
          ativo: this.valorDespesa.ativo
        });


        this.habilitarMes();
      });
  }

  getFases() {
    this._faseService.getAll()
      .finally(() => this.isLoading = false)
      .subscribe(
        fases => this.fases = fases,
        error => this.gerenciaErro(error)
      );
  }

  getTipoFornecedores() {
    this._financeiroService.getAllTipoForcecedores()
      .finally(() => this.isLoading = false)
      .subscribe(
        data => {
          this.tipoFornecedores = data;
        },
        error => {
          this.gerenciaErro(error);
        }
      );
  }

  getTipoDespesas(idUnidade, idFornecedor) {
    if (idUnidade === '' && idFornecedor === '') {
      this.tipoDespesas = [];
      return;
    }

    this._financeiroService.getAllByIdFornecedorUnidade(idUnidade, idFornecedor)
      .finally(() => this.isLoading = false)
      .subscribe(
        data => {
          this.tipoDespesas = data;
        },
        error => {
          this.gerenciaErro(error);
        }
      );
  }

  getTipoDespesaETipoFornecedor(idFornecedor, idFase, idUnidade) {
    this.getTipoDespesas(idUnidade, idFornecedor);
    this.getEditalCredenciamento(idFornecedor, idFase, idUnidade);
    this.habilitarMes();
  }

  getUnidadesByFase(idFase) {
    this.form.patchValue({ idUnidade: null, idTipoFornecedor: null });
    if (idFase === '') {
      this.unidades = [];
      return;
    }

    this._unidadeService.getUnidadesParticipantesByFase(idFase)
      .finally(() => this.isLoading = false)
      .subscribe(
        data => {
          this.unidades = data;
          // console.log(data);
        },
        error => {
          this.gerenciaErro(error);
        }
      );
  }

  getEditalCredenciamento(idFornecedor, idFase, idUnidade) {

    if (idFase === '' && idUnidade === '' && idFornecedor === '') {
      this.editais = [];
      return;
    }

    if (idFornecedor.toUpperCase() === TipoFornecedor.CFC || idFornecedor.toUpperCase() === TipoFornecedor.Clinica) {

      let idForn = (idFornecedor.toUpperCase() === TipoFornecedor.CFC ? Prestador.idCfc : Prestador.idClinica);
      this._editalCredenciamentoService.getEditalByIdUnidadeAnIdFase(idUnidade, idFase, idForn)
        .finally(() => this.isLoading = false)
        .subscribe(
          data => {
            this.editais = data;
          },
          error => {
            this.gerenciaErro(error);
          }
        );
    }
  }

  habilitaEdital(id) {
    if (id === undefined || id.value === '') {
      this.removeValidatorProperty('idEditalCredenciamento');
      this.form.patchValue({ idEditalCredenciamento: null });
      return false;
    }

    if (id.value === '63680567-3b19-4200-9a96-071cdcd1bf60' || id.value === '6999bc5a-23a8-4565-aab2-7590d1b92071') {
      // this.setValidatorProperty('idEditalCredenciamento', Validators.required);
      return true;
    }
    this.removeValidatorProperty('idEditalCredenciamento');
    this.form.patchValue({ idEditalCredenciamento: null });
    return false;
  }

  habilitarMes() {

    this.podeHabilitarMes = false;


    if(this.unidades != null && this.form.controls['idTipoFornecedor'] != null && this.form.controls['idUnidade'] != null){

      let fornecedor = this.form.controls['idTipoFornecedor'].value;
      let unidade = this.form.controls['idUnidade'].value;

      if(fornecedor != null && unidade != null){

        if (unidade === undefined || fornecedor === undefined) {
          this.removeValidatorProperty('mes');
          this.form.patchValue({ mes: null });
          this.podeHabilitarMes = false;
        }

        const un = this.unidades.find(x => x.idUnidade === unidade);
        if (un === undefined) {
          this.removeValidatorProperty('mes');
          this.form.patchValue({ mes: null });
          this.podeHabilitarMes = false;
          }



        if ((un.uf.siglaUf === 'PB' || un.uf.siglaUf === 'MS')
          && (fornecedor.toUpperCase() === TipoFornecedor.Detran || fornecedor.toUpperCase() === TipoFornecedor.Aluno)) {
          this.setValidatorProperty('mes', Validators.required);
          this.podeHabilitarMes = true;

        }
        this.removeValidatorProperty('mes');
        //this.form.patchValue({ mes: null });
      }

      }
  }

  setValidatorProperty(propiedade: string, validator) {
    this.form.controls[propiedade].setValidators(validator);
    this.form.controls[propiedade].updateValueAndValidity();
  }

  removeValidatorProperty(propiedade: string) {
    this.form.controls[propiedade].clearValidators();
    this.form.controls[propiedade].updateValueAndValidity();
  }

  cancelar() {
    this.confirmationService.confirm({
      message: 'Deseja cancelar?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {
        this.router.navigate(['/gerenciar-valor-despesa-fornecedor']);
      }
    });
  }

  submit() {
    this.isSubmitted = true;
    if (this.form.valid) {

      this.isLoading = true;
      this.confirmationService.confirm({
        message: 'Tem certeza que deseja salvar?',
        header: 'Confirmação',
        icon: 'fa fa-question-circle',
        accept: () => {
          this.isLoading = true;
          // console.log(this.form.value);
          this._financeiroService.cadastrarEditarValorDespesa(this.form.value)
            .finally(() => this.isLoading = false)
            .subscribe(
              data => {
                this.router.navigate(['/gerenciar-valor-despesa-fornecedor']);
                localStorage.setItem('mensagem', 'Cadastro salvo com sucesso!');
              },
              error => {
                this.isSubmitted = false;
                this.gerenciaErro(error);
              }
            );
        },
        reject: () => {
          this.isLoading = false;
          this.isSubmitted = false;
          this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Dados não enviados!' });
        }
      });

    } else {
      this.isLoading = false;
      this.isSubmitted = false;
      this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Campos obrigatórios não preenchidos!' });
    }

  }
}



// WEBPACK FOOTER //
// ./src/app/components/financeiro/cadastar-valor-despesa-fornecedor-form/cadastar-valor-despesa-fornecedor-form.component.ts